import { RootState } from '@/store/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Api } from '@/api/api';
import { Client } from "@/domain/client";

/**
 * Client store
 */
export interface ClientState {
  clients: Client[];
  clientToConnect: Client | undefined;
  clientToEdit: Client | undefined;
}

export const state: ClientState = {
  clients: [],
  clientToConnect: undefined,
  clientToEdit: undefined
};

export const getters: GetterTree<ClientState, RootState> = {
  getAllClients: state => state.clients,
  getAvailableClients: state => state.clients.filter(client => !client.connected),
  getClientToConnect: state => state.clientToConnect,
  getClientToEdit: state => state.clientToEdit
};

export const mutations: MutationTree<ClientState> = {
  SET_CLIENTS: (state, clients) => state.clients = clients,
  SET_CLIENT_TO_CONNECT: (state, clientId) => {
    state.clientToConnect = state.clients.find(client => client.id == clientId);
  },
  SET_CLIENT_TO_EDIT: (state, client) => state.clientToEdit = client
};

export const actions: ActionTree<ClientState, RootState> = {
  FETCH_CLIENTS({ commit }) {
    return Api.Client.getClients().then(response => {
      commit('SET_CLIENTS', response.clients)
    });
  },
  async SAVE_NEW_CLIENT({ commit }, newClient: Client) {
     return await Api.Client.saveNewClient(newClient);
  },
  async UPDATE_CLIENT({ commit }, updatedClient : Client) {
    return await Api.Client.updateClient(updatedClient);
  },
  async DELETE_CLIENT({ commit }, clientId : number) {
    return await Api.Client.deleteClient(clientId);
  }
};

export const ClientStore: Module<ClientState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
